var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentTerm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 68,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3994,
    y: 24.1868,
    width: 40.9178,
    height: 44.6376,
    transform: "rotate(-11.029 12.3994 24.1868)",
    fill: "#CCE5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15.1819,
    width: 39.7727,
    height: 43.9545,
    fill: "#027BC7",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.0454,
    width: 20.9545,
    height: 13.6363,
    rx: 1.5,
    fill: "#027BC7",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1819,
    y: 20.9546,
    width: 19.8636,
    height: 4.18181,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6819,
    y: 28.2727,
    width: 31.3636,
    height: 2.09091,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1592,
    y: 21.3188,
    width: 3.7198,
    height: 1.36393,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.23975,
    y: 17.5989,
    width: 21.0789,
    height: 1.36393,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1189,
    y: 21.3188,
    width: 3.7198,
    height: 1.36393,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6819,
    y: 34.5454,
    width: 31.3636,
    height: 2.09091,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6819,
    y: 40.8181,
    width: 31.3636,
    height: 2.09091,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6819,
    y: 48.1362,
    width: 21.9545,
    height: 2.09091,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7989,
    cy: 9.91946,
    r: 9.91946,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6329 19.0123C19.633 19.0123 15.5615 14.9438 15.5615 9.92767C15.5615 4.91149 19.633 0.82666 24.6329 0.82666C29.6327 0.82666 33.6825 4.91149 33.6825 9.92767C33.6825 14.9438 29.611 19.0069 24.6329 19.0069V19.0123ZM24.2963 15.0637H21.8262C21.6091 15.0637 21.4299 14.8839 21.4299 14.6661C21.4299 14.4482 21.6091 14.2685 21.8262 14.2685H25.0454C26.1312 14.2685 27.0215 13.3753 27.0215 12.286C27.0215 11.1967 26.1312 10.3253 25.0454 10.3253H24.4103C22.8903 10.3253 21.6417 9.07803 21.6417 7.54757C21.6417 6.01712 22.8251 4.85158 24.2909 4.79167V3.46274C24.2909 3.24488 24.47 3.06515 24.6872 3.06515C24.9043 3.06515 25.0834 3.24488 25.0834 3.46274V4.79167H27.2006C27.4178 4.79167 27.5969 4.97141 27.5969 5.18926C27.5969 5.40712 27.4178 5.58685 27.2006 5.58685H24.4157C23.33 5.58685 22.4397 6.48007 22.4397 7.54757C22.4397 8.61508 23.33 9.53008 24.4157 9.53008H25.0509C26.5709 9.53008 27.8195 10.761 27.8195 12.286C27.8195 13.811 26.5926 15.0201 25.0943 15.0637V16.3708C25.0943 16.5887 24.9369 16.7684 24.698 16.7684C24.4809 16.7684 24.3017 16.5887 24.3017 16.3708V15.0637H24.2963Z",
    fill: "#027BC7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.659,
    cy: 15.2044,
    r: 1.56818,
    fill: "#CCE5FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.75006,
    cy: 15.2044,
    r: 1.56818,
    fill: "#CCE5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTerm);
export default __webpack_public_path__ + "static/media/paymentTerm.a53b3ef43094903921ab0551066bf43e.svg";
export { ForwardRef as ReactComponent };